<template>
  <v-container grid-list-md fluid>

    Show an email invite send confimation dialog and confirmation once sent dialog

    <div class="crx-header">
      <span class="headline">Users</span>
    </div>

    <div>
      
      <div>
        <v-btn 
        rounded
        class="white--text crx-gradient-green font-weight-bold"
        @click="newUser">
          Add User
        </v-btn>
      </div>

      <!-- TABLE -->
      <table class="final-table th-no-padding lines-b pointer hover full-width">
        <colgroup ref="colgroup1">
          <col width="10px">
          <col width="10px">
          <col width="10px">
          <col width="10px">
        </colgroup>

        <tr class="unselectable">
          <td>
            Name
          </td>
          <td>
            Email
          </td>
          <td>
            Enabled
          </td>
          <td>
            
          </td>
        </tr>

        <user-row
        v-for="user in users" 
        :key="user.id"
        :item="user"
        @click.native="clickRow(user)"
        ></user-row>

      </table>
      <!-- TABLE -->

      <!--
      <c-real-table
      v-if="users.length > 0"
      ref="table"
      :headers="headers"
      :items="users"
      :sort="sort"
      :search="search"
      :leftOffset="79"
      :topOffset="48"
      scrollParent="window"
      primaryKey="id"
      @onDelete="onDelete">

        <template slot="mobile-toolbar">
          <v-btn 
          flat
          @click="newUser"
          class="c-btn-vert-caption">
            <v-icon color="light-blue">add</v-icon>
            <span class="caption-xs blue-grey--text text--darken-1">New</span>
          </v-btn>
        </template>

        <tri-row
        :vmode="0"
        slot="table-row"
        slot-scope="sprps"
        :key="sprps.item.tempID || sprps.item"
        :sprps="sprps"
        @click.native="clickRow(sprps.item)"
        ></tri-row>

        <tri-row
        :vmode="1"
        slot="phone-row"
        slot-scope="sprps"
        :key="sprps.item.tempID || sprps.item"
        :sprps="sprps"
        @click.native="clickRow(sprps.item)"
        ></tri-row>

      </c-real-table>
      -->

    </div>

    <user-dialog ref="dialog" @on-refresh="loadUsers"></user-dialog>

  </v-container>
</template>

<script>
// import TriRow from './components/TriRow'
import UserDialog from './components/UserDialog'
import UserRow from './components/NewUserRow'

export default {
  components: {
    // 'tri-row': TriRow,
    'user-dialog': UserDialog,
    UserRow
  },
  data () {
    return {
      saving: false,
      headers: ['Username', 'Email', 'Send request'],
      users: [],
      filters: {
        rowsPerPage: 15,
        sortCol: 'name',
        sortAscending: true,
        date: {
          mainSelect: 'is between',
          isInTheLast_select: 'days',
          isInTheLast_input: null,
          date1: null,
          date2: null,
        },
        search: {
          id: '',
          name: ''
        },
        active: {
          customer: false,
          date: false,
          deleted: false
        },
        categories: [],
        priceLists: []
      },
    }
  },
  computed: {
  },
  methods: {
    sort (headerIndex, items, sortAscending) {
      if (headerIndex === 0) { // Username
        return items.sort((a, b) => {
          return sortAscending ? a.username.localeCompare(b.username) : b.username.localeCompare(a.username)
        })
      } else if (headerIndex === 1) { // Email
        return items.sort((a, b) => {
          return sortAscending ? a.email.localeCompare(b.email) : b.email.localeCompare(a.email)
        })
      }
    },
    search (searchTerm, searchColumn, items) {
      var keywords = (searchTerm || '').toLowerCase().split(' ')
      if (searchColumn === 0) { // Username
        return items.filter(item => {
          return keywords.every(keyword => {
            return (item.username.toLowerCase()).indexOf(keyword) > -1
          })
        })
      }
      return items
    },
    onDelete (rows, done) {
      var idArray = rows.reduce((a, i) => {
        a.push(i.id)
        return a
      }, [])
      var title = 'Delete ' + idArray.length + ' user' + (idArray.length === 1 ? '' : 's') + '?'
      this.$root.$confirm(title, 'Are you sure?', { color: 'purple' }).then((confirm) => {
        if (confirm) {
          this.$axios.post('users/delete', idArray,
            {headers: {'X-Requested-With': 'XMLHttpRequest'}})
            .then(response => {
              done()
            })
            .catch(error => this.$root.$errorSnackbar(error))
        }
      })
    },
    clickRow (item) {
      // this.$refs.table.onRowClicked(item)
      this.$refs.dialog.edit(item)
    },
    newUser () {
      this.$refs.dialog.new()
    },
    inviteUser (userID, email) {
      var data = {
        id: userID,
        email: email
      }
      this.$axios.post('users/invite-user',
        data,
        {headers: {'Content-Type': 'application/json'}})
        .then(response => {
        })
        .catch(error => {
          this.$root.$errorSnackbar(error)
        })
    },
    loadUsers () {
      this.$axios.get(`/users`)
        .then(response => {
          this.users = response.data
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          // this.isLoading = false
        })
    }
  },

  created () {
    this.loadUsers()
  }
}
</script>
